// The router: `/` the sign-in page, `/<slug>/…` one workspace's console
// (02-DESIGN/03-console/01-the-console.md § the address). The router owns
// every address under the origin; the install's web server falls back to the
// page for any path with no file.

import { BrowserRouter, Route, Routes } from "react-router";

import type { PlatformProfile } from "./platform/profile.ts";
import { PageProvider } from "./platform/session.tsx";
import { SignInPage } from "./surfaces/entry/SignInPage.tsx";
import { WorkspaceRoute } from "./surfaces/workspace/WorkspaceRoute.tsx";

export function App({ origin, platform }: { origin: string; platform: PlatformProfile }) {
  return (
    <BrowserRouter>
      <PageProvider origin={origin} platform={platform}>
        <Routes>
          <Route path="/" element={<SignInPage />} />
          <Route path="/:slug/*" element={<WorkspaceRoute />} />
        </Routes>
      </PageProvider>
    </BrowserRouter>
  );
}
